/**
 * Token type for confirming an email or resetting password.
 */
export enum TokenConfirmationType {
  ConfirmEmail,
  PasswordReset,
}
